var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"500","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c(_vm.component,{ref:_vm.sharedRefs,tag:"component",attrs:{"shareUrlInfo":_vm.linkData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }